var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: { title: "活动数据", visible: _vm.show, size: "60%" },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
            close: _vm.close,
          },
        },
        [
          _c("div", { staticClass: "padding-x-20" }, [
            _c("div", { staticClass: "flex-start font-14 margin-bottom-10" }, [
              _c("span", [_vm._v("活动名称：")]),
              _c("span", [_vm._v(_vm._s(_vm.now.name || ""))]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-10" }, [
              _c("span", [_vm._v("隶属公司：")]),
              _c("span", [_vm._v(_vm._s(_vm.now.merchantNames || ""))]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "padding-y-20" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "text-center" }, [
                      _c("p", { staticClass: "margin-y-0 font-14 color-666" }, [
                        _vm._v("使用优惠数/订单总数"),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass:
                            "font-20 font-weight margin-top-5 color-main",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.summary.shiYongYouHuiCiShu || "0.00")
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "text-center" }, [
                      _c("p", { staticClass: "margin-y-0 font-14 color-666" }, [
                        _vm._v("优惠金额"),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass:
                            "font-20 font-weight margin-top-5 color-main",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.summary.shiYongYouHuiJinE || "0.00")
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "text-center" }, [
                      _c("p", { staticClass: "margin-y-0 font-14 color-666" }, [
                        _vm._v("订单金额合计"),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass:
                            "font-20 font-weight margin-top-5 color-main",
                        },
                        [_vm._v(_vm._s(_vm.summary.zhiFuZongJinE || "0.00"))]
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            {
              staticClass: "margin-top-10",
              attrs: { "body-style": { padding: "0" } },
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "agentTable",
                  attrs: {
                    data: _vm.list,
                    border: "",
                    "highlight-current-row": "",
                    "max-height": "680",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "用户账号",
                      width: "120",
                      prop: "userPhone",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "180",
                      label: "使用时间",
                      prop: "useTime",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "使用线路",
                      width: "120",
                      prop: "lineName",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "优惠金额(元)",
                      width: "120",
                      prop: "youhui",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "订单金额(元)",
                      width: "120",
                      prop: "payAmount",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "订单状态",
                      width: "120",
                      prop: "orderStatusStr",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "使用订单号",
                      width: "230",
                      prop: "orderNo",
                      "show-overflow-tooltip": true,
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyOrderNo(scope.row.orderNo)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.orderNo))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("el-pagination", {
                staticClass: "sameCity-pagination margin-top-10",
                attrs: {
                  "current-page": _vm.pagination.page,
                  "page-size": _vm.pagination.pageSize,
                  "page-sizes": [10, 20, 30, 50, 100],
                  total: _vm.pagination.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.pagination, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.pagination, "page", $event)
                  },
                  "current-change": _vm.handleCurrentChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }